function PageBanner({ title, subtitle, image, children }) {
  return (
    <section
      className="relative min-h-[400px] flex items-center justify-center text-center text-white overflow-hidden pt-24"
      style={{
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        backgroundPosition: "center"
      }}
    >
      {/* Subtle overlay for text readability */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>

      {/* Content container */}
      <div className="relative z-10 max-w-3xl px-6 py-8">

        <h1 className="text-4xl md:text-5xl font-luxury font-semibold mb-6 tracking-wide drop-shadow-lg brand-green-text">
          {title}
        </h1>

        {subtitle && (
          <p className="text-base md:text-lg mb-8 drop-shadow-md brand-white-text">
            {subtitle}
          </p>
        )}

        {/* Search Box - Clean white container */}
        <div className="mt-8">
          {children}
        </div>

      </div>
    </section>
  );
}

export default PageBanner;
